import { VariationCalc } from "../presentation/services/VariationCalc/VariationCalc";

export class GroupCompanyEntity {
    seriePreferenceValues = {};
    constructor(props, _id) {
        this.props = props;
        this._id = _id;
    }

    static restore(props) {
        const groupEntity = new GroupCompanyEntity(props, props._id);
        groupEntity.setSeriePreferenceValue();
        return groupEntity;
    }

    getCompaniesByElipssis(key, end = "", count = 2, start = "|") {
        if (!this.props?.summary?.[key]) return;
        const summaryCompanies = this.props?.summary?.[key].map((c) => c.name);
        if (!summaryCompanies?.length) return end;

        const elipssisCompanies = summaryCompanies.slice(0, count);

        return summaryCompanies.length
            ? `${start} ${elipssisCompanies.join(", ")}`
            : end;
    }

    async setSeriePreferenceValue() {
        const series = ["imposto", "receita", "lucro"];

        const preference = this.props?.performance?.series;
        for (const serieName of series) {
            let source = null;

            if (preference?.[serieName]?.simplesNacional?.value) {
                source = preference?.[serieName]?.simplesNacional;
            } else if (preference?.[serieName]?.tax?.value) {
                source = preference?.[serieName]?.tax;
            } else if (preference?.[serieName]?.fin) {
                source = preference?.[serieName]?.fin;
            } else if (preference?.[serieName]?.accounting) {
                source = preference?.[serieName]?.accounting;
            } else if (preference?.[serieName]?.personnel) {
                source = preference?.[serieName]?.personnel;
            } else if (preference?.[serieName]?.eSocial) {
                source = preference?.[serieName]?.eSocial;
            }

            if (source?.value) {
                const isDown = source.text?.includes("Queda");

                const isUp = source.text?.includes("Aumento");

                const polarity = source.polarity;

                let color = "color-gray-light";

                if ((isDown && polarity == -1) || (isUp && polarity == 1)) {
                    color = "color-cyan-dark";
                } else {
                    color = "color-purple-dark";
                }

                let icon = "fas fa-minus";

                if (isUp) {
                    icon = "fas fa-caret-up";
                } else if (isDown) {
                    icon = "fas fa-caret-down";
                }

                this.seriePreferenceValues[serieName] = {
                    value: source.value,
                    polarity: polarity,
                    valueFormatted: source.value.toLocaleString("pt-BR", {
                        style: "percent",
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    }),
                    tooltip: source.text,
                    variation: {
                        color,
                        icon
                    }
                };
            }
        }
    }
}
